import axios from "axios";

// base url to make requests
const instance = axios.create({
  baseUrl: process.env.REACT_APP_API_BASE_URL,
});

export default instance;
